<template>
  <div>
    <div :class="[c.bg200, c.text900]" class="px-6 pt-8 pb-6 mt-5 text-center">
      <div
        :class="c.border500"
        class="line-height-50 text-4-5xl font-bold border-6 rounded-full w-16 h-16 text-center mx-auto"
      >{{ rating }}</div>
      <div :class="c.text900" class="mt-4 mb-1 font-bold text-lg">{{ scoreNumbers[rating].title }}</div>
      <div :class="c.text900">{{ scoreNumbers[rating].info }}</div>
    </div>
    <div v-if="theLetters" :class="[c.bg100, c.text900]" class="px-6 py-2">
      <div v-for="(theKey, theVal) in infoLetters" :key="'key-' + theVal">
        <HistamineTypeToggle v-if="theLetters.includes('' + theVal)" class="py-2" :letter="infoLetters[theVal]" :c="c"/>
      </div>
    </div>
  </div>
</template>

<script>
import HistamineTypeToggle from '@/components/HistamineTypeToggle.vue'

export default {
  components: {
    HistamineTypeToggle
  },
  data() {
    return {
      infoLetters: {
        H: { title: "High histamine", info: "High histamine content" },
        "H!": {
          title: "Highly perishable",
          info: "Highly perishable, rapid formation of histamine"
        },
        A: { title: "Other amines", info: "Other biogenic amines" },
        L: {
          title: "Liberator",
          info: "Liberator of mast cell mediators (aka histamine liberator)"
        },
        B: {
          title: "Blocker",
          info:
            "Blocker (aka inhibitor) of diamine oxidase or of other histamine degrading enzymes"
        }
      },
      scoreNumbers: {
        "0": {
          title: "Well tolerated",
          info: "No symptoms expected at usual intake"
        },
        "1": {
          title: "Moderately compatible",
          info:
            "Minor symptoms, occasional consumption of small quantities is often tolerated"
        },
        "2": {
          title: "Incompatible",
          info: "Significant symptoms at usual intake"
        },
        "3": { title: "Very poorly tolerated", info: "Severe symptoms" },
        "?": {
          title: "Insufficient data",
          info: "Insufficient or contradictory information"
        }
      }
    };
  },
  props: {
    itemData: {
      type: Object
    },
    c: {
      type: Object
    }
  },
  computed: {
    rating() {
      return this.itemData.sco;
    },
    theLetters(){
      let theItem = this.itemData
      let letters = []
      let checkFor = ['H', 'A', 'L', 'B']
      for (let i = 0; i < checkFor.length; i++) {
        if (checkFor[i] in theItem) {
          letters.push(checkFor[i])
          if (checkFor[i] === 'H' && theItem.H === 'H!'){
            letters.pop()
            letters.push('H!')
          }
        }
      }
      return (letters.length === 0 ? false : letters)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
</style>
